/* Any copyright is dedicated to the Public Domain.
 http://creativecommons.org/publicdomain/zero/1.0/ */

// Original source code for the inline source map test.
// The generated file was made with
//    webpack --devtool source-map code_late_script.js code_bundle_late_script.js

"use strict";

function f() {
  console.log("The first version of the script");
}

f();
